import React from 'react';
import { IdentificationBadge, Copy } from '@phosphor-icons/react';
import { toast } from 'sonner';

/**
 * IdBadge — compact display chip that shows a user's or order's display id
 * with a one-click copy button. Falls back gracefully if the id is missing.
 */
const IdBadge = ({ id, label, testId = 'id-badge', size = 'sm' }) => {
  if (!id) return null;

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(id);
      toast.success(`Copied ${id}`);
    } catch {
      toast.error('Copy failed');
    }
  };

  const padding = size === 'lg' ? 'px-3 py-1.5 text-sm' : 'px-2 py-0.5 text-[11px]';

  return (
    <span
      className={`inline-flex items-center gap-1 bg-sand-100 border border-[#E8E1D5] text-text-secondary font-mono ${padding} rounded-full`}
      data-testid={testId}
      title={label ? `${label}: ${id}` : id}
    >
      <IdentificationBadge size={size === 'lg' ? 16 : 12} className="text-brand-primary" />
      {label && <span className="font-sans text-text-secondary/70 uppercase tracking-wider text-[9px]">{label}</span>}
      <span className="font-bold text-text-primary">{id}</span>
      <button
        type="button"
        onClick={onCopy}
        className="ml-0.5 text-text-secondary hover:text-brand-primary transition-colors"
        aria-label="Copy id"
        data-testid={`${testId}-copy`}
      >
        <Copy size={size === 'lg' ? 14 : 11} />
      </button>
    </span>
  );
};

export default IdBadge;
